import React from "react";
import { getClassDisplayName, getClassInstitutionName } from "../../utils/classPresentation";
import "./style.css";

export default function ClassPresentation({ schoolClass, fallback }) {
  return (
    <span className="class-presentation">
      <strong className="class-presentation-name">{getClassDisplayName(schoolClass, fallback)}</strong>
      {schoolClass && <small className="class-presentation-institution">{getClassInstitutionName(schoolClass)}</small>}
    </span>
  );
}
